import { useCallback, useRef, useState } from "react";

import { usePusherUserChannelSubscription } from "hooks/pusher";

const useDownload = (mutation) => {
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const promiseRef = useRef(null);

  const handleDownloadReady = useCallback((url) => {
    if (promiseRef.current) {
      promiseRef.current.resolve(url);
      promiseRef.current = null;
    }
  }, []);

  const handleDownloadError = useCallback((error) => {
    if (promiseRef.current) {
      promiseRef.current.reject(error);
      promiseRef.current = null;
    }
  }, []);

  usePusherUserChannelSubscription("download-ready", handleDownloadReady);
  usePusherUserChannelSubscription("download-error", handleDownloadError);

  const onDownload = useCallback(
    async (params = {}) => {
      setIsDownloadInProgress(true);

      const downloadPromise = new Promise((resolve, reject) => {
        promiseRef.current = { resolve, reject };
      });

      try {
        await mutation.mutateAsync(params, {
          onMutate: () => {
            setIsDownloadInProgress(true);
          },
        });

        const url = await downloadPromise;
        window.location.assign(url);
      } catch (error) {
        console.error("Download failed:", error);
      } finally {
        promiseRef.current = null;
        setIsDownloadInProgress(false);
      }
    },
    [mutation],
  );

  return {
    onDownload,
    isDownloadInProgress,
  };
};

export default useDownload;
